/**
 * @description: 内容服务费报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="or-nff-report">
        <div class="nff-list">
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="nffTime">
                        <input type="text" class="form-control laydate-icon" v-model="nffStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="nffEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="nffShop" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-3">包厢号:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="nffBox" data-placeholder="请选择包厢号"></select>
                </div>
                <label class="list-label-3">支付人:</label>
                <div class="col-md-2">
                    <input type="text" class="form-control" v-model="nff_user" placeholder="请输入支付人">
                </div>
            </div>
            <div class="row">
                <label class="list-label-4">实付总额:</label>
                <div class="list-total">{{nff_pay_total}}</div>
                <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitNffTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getNffExportSet">导出</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="nffList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="nffExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='nffExport_allcheck' @click='nffExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='nffExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='nffExport_checkModel' value="room_name">
                            <label>包厢号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='nffExport_checkModel' value="created_at">
                            <label>支付时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='nffExport_checkModel' value="ahead_user_name">
                            <label>支付人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='nffExport_checkModel' value="amount">
                            <label>实付金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='nffExport_checkModel' value="status_name">
                            <label>支付状态</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='nffExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='nffExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                nffStartTime: '',
                nffEndTime: '',
                nff_user: '',
                nff_pay_total: '',
                nffExport_allcheck: false,
                c_nffExport_allcheck: false,
                nffExport_checkModel: [],
                nffExport_checkData: ['shop_name', 'room_name', 'created_at', 'ahead_user_name', 'amount', 'status_name'],
                nffExport_type: 1,
            }
        },
        watch: {
            nffExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.nffExport_checkModel.length >= this.nffExport_checkData.length) {
                        this.nffExport_allcheck = true;
                        this.c_nffExport_allcheck = true;
                    } else {
                        this.nffExport_allcheck = false;
                        this.c_nffExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            this.nffStartTime = moment().hour('8').minute('0').format('YYYY-MM-DD HH:mm');
            this.nffEndTime = moment().add(1, 'day').hour('8').minute('0').format('YYYY-MM-DD HH:mm');
            this.innitDate(); // 日期
            this.shopDatas = [];
            this.innitInput(); // 门店
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.nffStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.nffEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.nffStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.nffEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.nffTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour('8').minute('0').toDate(),
                    endDate: moment().add(1, 'day').hour('8').minute('0').toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.nffStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.nffEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.nffShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    // 包厢号
                                    $(_this.$refs.nffBox).val('').trigger('change');
                                    $(_this.$refs.nffBox).prop('disabled', true);
                                    return;
                                }
                                // 包厢号
                                $(_this.$refs.nffBox).prop('disabled', false);
                                _this.getRoomdata(e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.nffShop).val(data.response.result[1].id).trigger('change');
                            // 包厢号
                            $(_this.$refs.nffBox).prop('disabled', false);
                            _this.getRoomdata(data.response.result[1].id);
                            _this.setShopDefaultTime(data.response.result[1].id);
                            _this.innitNffTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取包厢数据
            getRoomdata: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "Shop/getAllRoom",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let roomDatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                roomDatas.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.nffBox).html("");
                            $(_this.$refs.nffBox).select2({
                                data: roomDatas,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {}
                });
            },



            // 表格
            innitNffTable: function() {
                let _this = this;
                $(_this.$refs.nffList).bootstrapTable('destroy');
                $(_this.$refs.nffList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getNffList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        valign: 'middle',
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "10%",
                        valign: 'middle'
                    }, {
                        field: "room_name",
                        title: "包厢号",
                        width: "9%",
                        valign: 'middle'
                    }, {
                        field: "created_at",
                        title: "支付时间",
                        width: "12%",
                        valign: 'middle'
                    }, {
                        field: "ahead_user_name",
                        title: "支付人",
                        width: "10%",
                        valign: 'middle'
                    }, {
                        field: "amount",
                        title: "实付金额",
                        width: "9%",
                        valign: 'middle'
                    }, {
                        field: "status_name",
                        title: "支付状态",
                        width: "9%",
                        valign: 'middle'
                    }],
                });
            },
            // 数据
            getNffList: function(params) {
                let _this = this,
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_time": _this.nffStartTime,
                            "end_time": _this.nffEndTime,
                            "shop_id": $(_this.$refs.nffShop).val(),
                            "room_id": $.trim($(_this.$refs.nffBox).val()),
                            "ahead_user_name": _this.nff_user
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport2/getConentPriceOrders",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(pageNumber == '1') {
                                _this.nff_total = data.response.data.total;
                                _this.nff_pay_total = data.response.data.total_amount;
                            }
                            params.success({
                                total: _this.nff_total,
                                rows: data.response.data.rows
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getNffExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport2/contentPriceExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.nffExport_checkModel = data.response.result.export_fields;
                                _this.nffExport_type = data.response.result.export_type;
                            } else {
                                _this.nffExport_checkModel = _this.nffExport_checkData;
                                _this.nffExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.nffExport_alert)
                }, function() {
                    _this.exportNffList();
                });
            },
            // 导出字段全选
            nffExportCheckedAll: function() {
                let _this = this;
                _this.nffExport_allcheck = _this.c_nffExport_allcheck;
                if(!_this.nffExport_allcheck) { // 实现全选
                    _this.nffExport_checkModel = [];
                    _this.nffExport_checkData.forEach(function(item) {
                        _this.nffExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.nffExport_checkModel = [];
                }
            },
            // 导出
            exportNffList: function() {
                let _this = this;
                let export_fields = JSON.stringify(_this.nffExport_checkModel);

                window.location.href = Vue.ctUrl + "FinanceReport2/contentPriceExport?" +
                    "start_time=" + _this.nffStartTime +
                    "&end_time=" + _this.nffEndTime +
                    "&shop_id=" + $(_this.$refs.nffShop).val() +
                    "&room_id=" + $.trim($(_this.$refs.nffBox).val()) +
                    "&ahead_user_name=" + _this.nff_user +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.nffExport_type;
                // debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>